export const QUANTITY_MAX = 6;
export const DEFAULT_QUANTITY = 1;
